import Swiper, { Navigation, Pagination } from 'swiper';

const InitSwiper = (element, parameters) => {
  console.log('clients swiper');
  const swiper = new Swiper(element, {
    modules: [Navigation, Pagination],
    ...parameters
  });
}

export default InitSwiper;
